import { FormControl, FormHelperText } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export interface DateAdapterProps {
  name: string;
  label: string;
  input: any;
  meta: any;
  loading: boolean;
  required: boolean;
  options: any;
  disableFuture?: boolean;
}

const DateAdapter = ({
  name,
  input,
  meta,
  loading,
  options,
  label,
  required,
  disableFuture,
  ...rest
}: DateAdapterProps) => {
  return (
    <>
      <FormControl error={!!meta.error} {...rest}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            {...rest}
            disableFuture={disableFuture}
            views={["year", "month", "day"]}
            label={label}
            value={input.value && new Date(input.value)}
            onChange={(value: any | null) => value && input.onChange(value.toLocaleDateString("en-za"))}
            slotProps={{ toolbar: { hidden: true }, textField: {size:"small", margin:"dense", required } }}
            format="dd/MM/yyyy"
          />
        </LocalizationProvider>
        {!!meta.error ? (
          <FormHelperText>{meta.error}</FormHelperText>
        ) : (
          <></>
        )}
      </FormControl>
    </>
  );
};

export default DateAdapter;
